<template>
  <div class="row no-gutters">
    <div class="col-12">
      <div
        class="row no-gutters justify-content-space-evenly statistics-header"
      >
        <div
          v-bind:class="{ 'tab-header-clicked': raceIndexTabStates.horseIndex }"
          v-on:click="onWhosHotTabClicked('horseIndex')"
          class="col-5 col-md-2 text tab-header text-center"
        >
          <span>HORSE INDEX</span>
        </div>
        <div
          v-bind:class="{
            'tab-header-clicked': raceIndexTabStates.jockeyIndex,
          }"
          v-on:click="onWhosHotTabClicked('jockeyIndex')"
          class="col-5 col-md-2 text tab-header text-center"
        >
          <span>JOCKEY INDEX</span>
        </div>
        <div
          v-bind:class="{
            'tab-header-clicked': raceIndexTabStates.trainerIndex,
          }"
          v-on:click="onWhosHotTabClicked('trainerIndex')"
          class="col-5 col-md-2 text tab-header text-center"
        >
          <span>TRAINER INDEX</span>
        </div>
      </div>
      <div v-if="raceIndexTabStates.horseIndex" class="col-12 p-0">
        <div class="row no-gutters">
          <div style="position: relative" class="col-12 col-md-4">
            <div class="table-responsive">
              <table class="table">
                <thead class="thead-dark">
                  <tr class="no-border">
                    <th scope="col"></th>
                    <th class="text-center" scope="col">RACE</th>
                    <th class="text-center" scope="col">NO.</th>
                    <th scope="col">HORSE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(horseIndex, index) in visibleHorseIndexData[0]"
                    :key="index"
                    class="no-border"
                  >
                    <td
                      class="text-center clickable-text"
                      scope="row"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      <img class="jockey-silk" :src="horseIndex.silkPath" />
                    </td>
                    <td
                      class="text-center clickable-text"
                      scope="row"
                      v-on:click="onRaceClicked(horseIndex.raceNumber)"
                    >
                      {{ horseIndex.raceNumber }}
                    </td>
                    <td
                      class="text-center clickable-text"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      {{ horseIndex.horseNumber }}
                    </td>
                    <td
                      class="horse-name font-weight-bold clickable-text"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      {{ horseIndex.horseName }}
                    </td>
                  </tr>
                  <tr
                    v-for="(horseIndex, index) in visibleHorseIndexData[1]"
                    :key="index"
                    class="no-border d-md-none"
                  >
                    <td class="text-center clickable-text" scope="row">
                      <img
                        class="jockey-silk text-center"
                        :src="horseIndex.silkPath"
                      />
                    </td>
                    <td
                      class="text-center clickable-text"
                      scope="row"
                      v-on:click="onRaceClicked(horseIndex.raceNumber)"
                    >
                      {{ horseIndex.raceNumber }}
                    </td>
                    <td
                      class="text-center clickable-text"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      {{ horseIndex.horseNumber }}
                    </td>
                    <td
                      class="horse-name font-weight-bold clickable-text"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      {{ horseIndex.horseName }}
                    </td>
                  </tr>
                  <tr
                    v-for="(horseIndex, index) in visibleHorseIndexData[2]"
                    :key="index"
                    class="no-border d-md-none"
                  >
                    <td
                      scope="row"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      <img class="jockey-silk" :src="horseIndex.silkPath" />
                    </td>
                    <td class="text-center clickable-text" scope="row">
                      {{ horseIndex.raceNumber }}
                    </td>
                    <td
                      class="text-center clickable-text"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      {{ horseIndex.horseNumber }}
                    </td>
                    <td
                      class="horse-name font-weight-bold clickable-text"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      {{ horseIndex.horseName }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            style="position: relative"
            class="col-12 col-md-4 d-none d-md-block"
          >
            <div class="table-responsive">
              <table class="table">
                <thead class="thead-dark">
                  <tr class="no-border">
                    <th scope="col"></th>
                    <th class="text-center" scope="col">RACE</th>
                    <th class="text-center" scope="col">NO.</th>
                    <th scope="col">HORSE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(horseIndex, index) in visibleHorseIndexData[1]"
                    :key="index"
                    class="no-border"
                  >
                    <td
                      class="text-center clickable-item"
                      scope="row"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      <img class="jockey-silk" :src="horseIndex.silkPath" />
                    </td>
                    <td
                      class="text-center clickable-text"
                      scope="row"
                      v-on:click="onRaceClicked(horseIndex.raceNumber)"
                    >
                      {{ horseIndex.raceNumber }}
                    </td>
                    <td
                      class="text-center clickable-text"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      {{ horseIndex.horseNumber }}
                    </td>
                    <td
                      class="horse-name font-weight-bold clickable-text"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      {{ horseIndex.horseName }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            style="position: relative"
            class="col-12 col-md-4 d-none d-md-block"
          >
            <div class="table-responsive">
              <table class="table">
                <thead class="thead-dark">
                  <tr class="no-border">
                    <th scope="col"></th>
                    <th class="text-center" scope="col">RACE</th>
                    <th class="text-center" scope="col">NO.</th>
                    <th scope="col">HORSE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(horseIndex, index) in visibleHorseIndexData[2]"
                    :key="index"
                    class="no-border"
                  >
                    <td
                      class="text-center clickable-text clickable-item"
                      scope="row"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      <img class="jockey-silk" :src="horseIndex.silkPath" />
                    </td>
                    <td
                      class="text-center clickable-text"
                      scope="row"
                      v-on:click="onRaceClicked(horseIndex.raceNumber)"
                    >
                      {{ horseIndex.raceNumber }}
                    </td>
                    <td
                      class="text-center clickable-text"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      {{ horseIndex.horseNumber }}
                    </td>
                    <td
                      class="horse-name font-weight-bold clickable-text"
                      v-on:click="
                        onHorseClicked(
                          horseIndex.raceNumber,
                          horseIndex.horseNumber,
                        )
                      "
                    >
                      {{ horseIndex.horseName }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="raceIndexTabStates.jockeyIndex" class="col-12 p-0">
        <div class="row no-gutters">
          <div style="position: relative" class="col-12 col-md-4 my-1">
            <div class="table-responsive">
              <table class="table">
                <tbody
                  v-for="(jockeyIndex, index) in jockeyIndexChunk[0]"
                  :key="index"
                >
                  <tr class="no-border">
                    <td
                      colspan="3"
                      class="font-weight-bold clickable-text"
                      v-on:click="onRaceClicked(previousRun.raceNumber)"
                    >
                      {{
                        jockeyIndex.jockeyName | jtindex
                      }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                        jockeyIndex.jockeyStats
                      }}
                    </td>
                  </tr>
                  <tr
                    class="no-border"
                    v-for="(previousRun, index) in jockeyIndex.jockeyDetails"
                    :key="index"
                  >
                    <td
                      class="clickable-text"
                      v-on:click="onRaceClicked(previousRun.raceNumber)"
                    >
                      {{ previousRun.raceNumber }}-{{ previousRun.horseNumber }}
                    </td>
                    <td
                      class="clickable-text"
                      v-on:click="
                        onHorseClicked(
                          previousRun.raceNumber,
                          previousRun.horseNumber,
                        )
                      "
                    >
                      {{ previousRun.horseName }}
                    </td>
                    <td class="clickable-text">
                      {{ previousRun.trainerName || "Trainer Name" | jtindex }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="position: relative" class="col-12 col-md-4 my-1">
            <div class="table-responsive">
              <table class="table">
                <tbody
                  v-for="(jockeyIndex, index) in jockeyIndexChunk[1]"
                  :key="index"
                >
                  <tr class="no-border">
                    <td colspan="3" class="font-weight-bold clickable-text">
                      {{
                        jockeyIndex.jockeyName | jtindex
                      }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                        jockeyIndex.jockeyStats
                      }}
                    </td>
                  </tr>
                  <tr
                    class="no-border"
                    v-for="(previousRun, index) in jockeyIndex.jockeyDetails"
                    :key="index"
                  >
                    <td
                      class="clickable-text"
                      v-on:click="onRaceClicked(previousRun.raceNumber)"
                    >
                      {{ previousRun.raceNumber }}-{{ previousRun.horseNumber }}
                    </td>
                    <td
                      class="clickable-text"
                      v-on:click="
                        onHorseClicked(
                          previousRun.raceNumber,
                          previousRun.horseNumber,
                        )
                      "
                    >
                      {{ previousRun.horseName }}
                    </td>
                    <td class="clickable-text">
                      {{ previousRun.trainerName || "Trainer Name" | jtindex }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="position: relative" class="col-12 col-md-4">
            <div class="table-responsive">
              <table class="table">
                <tbody
                  v-for="(jockeyIndex, index) in jockeyIndexChunk[2]"
                  :key="index"
                >
                  <tr class="no-border">
                    <td colspan="3" class="font-weight-bold clickable-text">
                      {{
                        jockeyIndex.jockeyName | jtindex
                      }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                        jockeyIndex.jockeyStats
                      }}
                    </td>
                  </tr>
                  <tr
                    class="no-border"
                    v-for="(previousRun, index) in jockeyIndex.jockeyDetails"
                    :key="index"
                  >
                    <td
                      class="clickable-text"
                      v-on:click="onRaceClicked(previousRun.raceNumber)"
                    >
                      {{ previousRun.raceNumber }}-{{ previousRun.horseNumber }}
                    </td>
                    <td
                      class="clickable-text"
                      v-on:click="
                        onHorseClicked(
                          previousRun.raceNumber,
                          previousRun.horseNumber,
                        )
                      "
                    >
                      {{ previousRun.horseName }}
                    </td>
                    <td class="clickable-text">
                      {{ previousRun.trainerName || "Trainer Name" | jtindex }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="raceIndexTabStates.trainerIndex" class="col-12 p-0">
        <div class="row no-gutters">
          <div style="position: relative" class="col-12 col-md-4 my-1">
            <div class="table-responsive">
              <table class="table">
                <tbody
                  v-for="(trainerIndex, index) in trainerIndexChunk[0]"
                  :key="index"
                >
                  <tr class="no-border">
                    <td colspan="3" class="font-weight-bold clickable-text">
                      {{
                        trainerIndex.trainerName | jtindex
                      }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                        trainerIndex.trainerStats
                      }}
                    </td>
                  </tr>
                  <tr
                    class="no-border"
                    v-for="(previousRun, index) in trainerIndex.trainerDetails"
                    :key="index"
                  >
                    <td
                      class="clickable-text"
                      v-on:click="onRaceClicked(previousRun.raceNumber)"
                    >
                      {{ previousRun.raceNumber }}-{{ previousRun.horseNumber }}
                    </td>
                    <td
                      class="clickable-text"
                      v-on:click="
                        onHorseClicked(
                          previousRun.raceNumber,
                          previousRun.horseNumber,
                        )
                      "
                    >
                      {{ previousRun.horseName }}
                    </td>
                    <td class="clickable-text">
                      {{ previousRun.jockeyName || "Jockey Name" | jtindex }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="position: relative" class="col-12 col-md-4 my-1">
            <div class="table-responsive">
              <table class="table">
                <tbody
                  v-for="(trainerIndex, index) in trainerIndexChunk[1]"
                  :key="index"
                >
                  <tr class="no-border">
                    <td colspan="3" class="font-weight-bold clickable-text">
                      {{
                        trainerIndex.trainerName | jtindex
                      }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                        trainerIndex.trainerStats
                      }}
                    </td>
                  </tr>
                  <tr
                    class="no-border"
                    v-for="(previousRun, index) in trainerIndex.trainerDetails"
                    :key="index"
                  >
                    <td
                      class="clickable-text"
                      v-on:click="onRaceClicked(previousRun.raceNumber)"
                    >
                      {{ previousRun.raceNumber }}-{{ previousRun.horseNumber }}
                    </td>
                    <td
                      class="clickable-text"
                      v-on:click="
                        onHorseClicked(
                          previousRun.raceNumber,
                          previousRun.horseNumber,
                        )
                      "
                    >
                      {{ previousRun.horseName }}
                    </td>
                    <td class="clickable-text">
                      {{ previousRun.jockeyName || "Jockey Name" | jtindex }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="position: relative" class="col-12 col-md-4 my-1">
            <div class="table-responsive">
              <table class="table">
                <tbody
                  v-for="(trainerIndex, index) in trainerIndexChunk[2]"
                  :key="index"
                >
                  <tr class="no-border">
                    <td colspan="3" class="font-weight-bold clickable-text">
                      {{
                        trainerIndex.trainerName | jtindex
                      }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                        trainerIndex.trainerStats
                      }}
                    </td>
                  </tr>
                  <tr
                    class="no-border"
                    v-for="(previousRun, index) in trainerIndex.trainerDetails"
                    :key="index"
                  >
                    <td
                      class="clickable-text"
                      v-on:click="onRaceClicked(previousRun.raceNumber)"
                    >
                      {{ previousRun.raceNumber }}-{{ previousRun.horseNumber }}
                    </td>
                    <td
                      class="clickable-text"
                      v-on:click="
                        onHorseClicked(
                          previousRun.raceNumber,
                          previousRun.horseNumber,
                        )
                      "
                    >
                      {{ previousRun.horseName }}
                    </td>
                    <td class="clickable-text">
                      {{ previousRun.jockeyName || "Jockey Name" | jtindex }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import jockeyTrainer from "../components/mixins/Jockey-TrainerName";
import { HotJockeys } from "../assets/mockData/hotJockeys";
import { RaceJockeyIndexMock } from "../assets/mockData/raceJockeyIndex";
import { JockeySilksDateMappings } from "./configuration/jockeySilksDateMappings";
import { JockeySilks } from "./configuration/jockeySilksMapping.constant";
import { RaceCardService } from "../services/raceCard.service";

export default {
  name: "RaceIndex",
  mixins: [jockeyTrainer],
  computed: mapState([
    "selectedRaceCard",
    "selectedRaceStats",
    "selectedRaceCardSummary",
    "raceStatsIndex",
  ]),
  data: function () {
    return {
      raceIndexTabStates: {
        horseIndex: true,
        jockeyIndex: false,
        trainerIndex: false,
      },
      visibleHorseIndexData: [],
      horseIndexData: [],
      jockeyIndexData: RaceJockeyIndexMock,
      trainerIndexData: HotJockeys,
      areRaceResultsExpanded: false,
      jockeyIndexChunk: undefined,
    };
  },
  methods: {
    getImage(imagePath, fileType = "svg") {
      return require("../assets/images/" + imagePath + "." + fileType);
    },
    onWhosHotTabClicked(tabName) {
      if (this.raceIndexTabStates[tabName]) return;
      for (let tab in this.raceIndexTabStates) {
        if (this.raceIndexTabStates[tab] && tabName === tab) {
          this.raceIndexTabStates[tab] = false;
          return;
        }
        this.raceIndexTabStates[tab] = tab === tabName;
      }
    },
    toggleExtraRaceResults() {
      // const rotationDeg = this.areRaceResultsExpanded ? '0' : '180';
      // document.querySelector(`#extra-rows-down-arrow-${id}`).style.transform = "rotate(" + rotationDeg + "deg)";
      // this.areRaceResultsExpanded = !this.areRaceResultsExpanded;
      // this.horseIndexData = this.areRaceResultsExpanded ? this.hotJockeys : this.hotJockeys.slice(0, 8);
    },
    getChunkArray(targetArray, chunkSplit) {
      let result = [];
      for (let i = chunkSplit; i > 0; i--) {
        result.push(targetArray.splice(0, Math.ceil(targetArray.length / i)));
      }
      return result;
    },
    getHorseIndexDataImagePaths() {
      return this.selectedRaceStats.horseIndex.map((horseIndex) => {
        const basePath =
            "https://winningform.blob.core.windows.net/jockey-silks/",
          courseName =
            JockeySilks[
              this.selectedRaceCardSummary.raceCardSummary.raceTrackAssetId
            ].silkCourseName,
          dateSplit = this.selectedRaceCardSummary.raceCardSummary.raceDate
            .split("-")[1]
            .split(" "),
          dateNumber = dateSplit[1],
          dateMonth = JockeySilksDateMappings[dateSplit[2]],
          raceNumber = horseIndex.raceNumber,
          horseNumber = horseIndex.horseNumber,
          SAS =
            "?sp=r&st=2026-03-02T05:31:46Z&se=2027-12-31T13:46:46Z&spr=https&sv=2024-11-04&sr=c&sig=b9DBwuC35rGfppV9RGeDQuAa9Q%2FXTgzVqRAQ6N%2FZqos%3D",
          silkPath = `${basePath}${dateNumber}_${dateMonth}_${courseName}_${raceNumber}_${horseNumber}.jpg${SAS}`;

        horseIndex.silkPath = silkPath;
        return horseIndex;
      });
    },
    onHorseClicked(raceNumber, horseNumber) {
      this.setIsLoading(true);
      this.setSelectedRaceCardHorseIndex(horseNumber);
      RaceCardService.getRace(
        this.selectedRaceCardSummary.raceInformation[raceNumber - 1].id,
        this.onRaceCardResponse.bind(this),
      );
    },
    onRaceClicked(raceNumber) {
      this.setIsLoading(true);
      this.setSelectedRaceCardHorseIndex(raceNumber);
      RaceCardService.getRace(
        this.selectedRaceCardSummary.raceInformation[raceNumber - 1].id,
        this.onRaceCardResponse.bind(this),
      );
    },
    onRaceCardResponse(response) {
      const selectedRace = response;
      this.setSelectedRaceCard(this.selectedRaceCardSummary);
      this.setSelectedRace(selectedRace);
      this.setIsLoading(false);
      this.setRaceStatsIndex(this.raceIndexTabStates);
      this.$router.push({ path: `/landing/racecard` });
    },
    ...mapMutations([
      "setSelectedRaceCard",
      "setSelectedRace",
      "setIsLoading",
      "setSelectedRaceCardHorseIndex",
      "setRaceStatsIndex",
    ]),
  },
  mounted: function () {
    if (this.raceStatsIndex) {
      this.raceIndexTabStates = this.raceStatsIndex;
    }
    this.horseIndexData = this.getHorseIndexDataImagePaths();
    this.visibleHorseIndexData = this.getChunkArray(this.horseIndexData, 3);
    this.jockeyIndexChunk = this.getChunkArray(
      [...this.selectedRaceStats.jockeyIndex],
      3,
    );
    this.trainerIndexChunk = this.getChunkArray(
      [...this.selectedRaceStats.trainerIndex],
      3,
    );
  },
};
</script>

<style scoped>
.statistics-header {
  background-color: #000000;
}

.statistics-title-text {
  font-size: 1.8rem;
}

.tab-header {
  font-size: 0.8rem;
  padding: 0.5rem 0;
  font-weight: bold;
}

.tab-header:hover {
  cursor: pointer;
}

.tab-header-clicked {
  background-color: #ffffff;
  color: #000000;
}

.highlighted-table-cell {
  background-color: #f2f2f2;
}

.jockey-silk {
  width: 30px;
  height: 30px;
}

.extra-rows-toggle-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  background-color: #000000;
  padding: 0 !important;
  border: 1px solid #7c7c7c !important;
  margin-bottom: 0.5rem !important;
  box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
}

.extra-rows-down-arrow {
  height: 35px;
  font-weight: bolder;
}

.no-border {
  border: 0;
  border-style: hidden;
}

th {
  font-size: 0.8rem;
  border: none;
  text-decoration: none;
}

.center-horse-index-table-header {
  padding-right: 1px;
}

td {
  padding: 0.2rem 0.5rem;
}

.horse-name {
  font-size: 0.7rem;
}

@media (min-width: 1200px) {
  .tab-header {
    font-size: 1rem;
    padding: 0.5rem 0;
    font-weight: bold;
  }
}
</style>
